// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"welcome-module--jumbotron--10p_4","display4":"welcome-module--display4--2BsDs"};